import { useNonPathologyWorklist } from './pathology.queries';
import { departmentReportStatusOptions } from './pathology.utils';
import { WorklistPage } from './WorklistPage';

export const NonPathologyPage = () => (
  <WorklistPage
    eyebrow="Investigation"
    title="Non-Pathology"
    description="Non-lab investigations awaiting a report."
    useWorklist={useNonPathologyWorklist}
    actionLabel="Generate"
    action="mark-ready"
    emptyTitle="No pending non-pathology tests"
    emptyMessage="Tests tagged Non-Pathology in Settings > Charges will appear here until their report is generated."
    showReportUpdate
    reportUpdateBulk={false}
    statusOptions={departmentReportStatusOptions}
    defaultStatus="all"
  />
);
